import remove from 'lodash/remove';
import isAfter from 'date-fns/is_after';

import dobbyscan from 'dobbyscan';

import { types as actions } from '../actions';

import { TagSerializer } from '../../models';
import {SUPER_TAG, listViewColumns, FILTER_TYPE} from '../../constants/data';


const defaultState = {
  data: [],
  firstPageLoaded: false,
  filters: [],
  selected: null,
  bulkResults: {},
  currentTag: {},
  currentHistory: [],
  loading: false,
  totalPaginatedDataCount: 0,
  sorting: {
    column: listViewColumns[0],
    descendingOrder: false
  },
  field1FilterValues: [],
  field2FilterValues: []
};
const OLD_DATE_FOR_SORT = new Date('1975-01-01 00:00');

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.EDITED_CATEGORY: {
      const data = state.data.map(tag => {
        if (tag.category && tag.category.id === action.category.id) {
          tag.category = action.category;
          tag.categoryName = action.category.name;
        }
        return tag;
      });
      return {
        ...state,
        data
      };
    }
    case actions.EDITED_GROUP: {
      const data = state.data.map(tag => {
        if (tag.group && tag.group.id === action.group.id) {
          tag.group = action.group;
          tag.groupName = action.group.name;
        }
        return tag;
      });
      return {
        ...state,
        data
      };
    }
    case actions.REMOVE_CATEGORY: {
      const data = state.data.map(tag => {
        if (tag.category && tag.category.id === action.category.id) {
          tag.category = action.category.categoryReplacement;
          tag.categoryName = (action.category.categoryReplacement && action.category.categoryReplacement.name) || '';
        }
        return tag;
      });
      return {
        ...state,
        data
      };
    }
    case actions.REMOVE_GROUP: {
      const data = state.data.map(tag => {
        if (tag.group && tag.group.id === action.groupId) {
          delete tag.group;
          tag.groupName = '';
        }
        return tag;
      });
      return {
        ...state,
        data
      };
    }
    case actions.GET_AREAS:
      return {
        ...defaultState
      };
    case actions.GET_TAGS:
      return {
        ...state,
        loading: true
      };
    case actions.SET_TAGS: {
      const data = action.tags.data;
 
      return {
        ...state,
        data,
        totalPaginatedDataCount: action.tags.total,
        loading: false,
        firstPageLoaded: true
      };
    }
    case actions.EXPAND_COLLAPSE_TAG: {
      const data = state.data.map((tag) => {
        if(tag.id===action.id){
          tag.isExpanded = !tag.isExpanded
        }
        return tag;
      });

      return {
        ...state,
        data
      };
    }
    case actions.SELECT_TAG:
      return {
        ...state,
        selected: state.selected === action.id ? null : action.id
      };
    case actions.CLEAR_TAGS:
      return {
        ...state,
        data: []
      }
    case actions.SET_CURRENT_TAG:
      return {
        ...state,
        currentTag: action.tag
      };
    case actions.ADD_FILTER: { // todo Add UPDATE_FILTER action
      let filters = state.filters;
      if (action.filter.type === FILTER_TYPE.SEARCH) {
        filters = [...filters, action.filter];
      } else {
        const filterFoundIndex = filters.findIndex(filter => filter.column && filter.column.toLowerCase() === action.filter.column.toLowerCase());
        if (filterFoundIndex < 0) {
          filters = [...filters, action.filter];
        } else {
          filters[filterFoundIndex] = action.filter;
          filters = [...filters];
        }
      }
      return { ...state, filters };
    }
    case actions.REMOVE_FILTER: {
      let filters = [...state.filters];
      remove(filters, action.filter);
      return { ...state, filters };
    }
    case actions.CLEAR_FILTERS:
      return {
        ...state,
        filters: []
      };
    case actions.UPDATE_TAG: {
      let newInfo = action.tag;
      const data = state.data.map(tag => {
        if (
          tag.id === newInfo.id &&
          isAfter(newInfo.time.lastEventTime, tag.time.lastEventTime)
        ) {
          if (newInfo.lastSeen) {
            tag.lastSeen = newInfo.lastSeen;
          }
          tag.time = {
            ...tag.time,
            lastEventTime: newInfo.time.lastEventTime,
            isLastEventTimeValid: newInfo.time.isLastEventTimeValid,
            lastEventTimeDiff: newInfo.time.lastEventTimeDiff
          };
          if(tag.deviceType === SUPER_TAG){
            tag.time.deviceType = SUPER_TAG;
          }
          if (newInfo.location) {
            if (
              (newInfo.location.macAddress &&
                tag.location.macAddress !==
                  newInfo.location.macAddress) ||
              (!newInfo.location.macAddress &&
                (tag.latitude !== newInfo.latitude ||
                  tag.longitude !== newInfo.longitude))
            ) {
              tag.time = {
                ...tag.time,
                locationTime: newInfo.time.locationTime,
                isLocationTimeValid: newInfo.time.isLocationTimeValid,
                locationTimeDiff: newInfo.time.locationTimeDiff
              };
              if(tag.helpTag){
                if(newInfo.msgType === 3){
                  tag.location = newInfo.location;
                  tag.latitude = newInfo.latitude;
                  tag.longitude = newInfo.longitude;
                  tag.zone = newInfo.zone;
                  if(newInfo.source){
                    tag.source = newInfo.source;
                  }
                }else{
                  tag.location = {}; //todo: NOT do this, you can't be both
                  tag.latitude = 0;
                  tag.longitude = 0;
                  tag.zone = {};
                }
              }else{
                tag.location = newInfo.location;
                tag.locationName = newInfo.locationName
                tag.latitude = newInfo.latitude;
                tag.longitude = newInfo.longitude;
                tag.zone = newInfo.zone;
                if(newInfo.source){
                  tag.source = newInfo.source;
                }
              }                      
            } else {
              let t = TagSerializer.normalizeTimeValue(
                tag.time.locationTime
              );
              tag.time = {
                ...tag.time,
                locationTimeDiff: t.timeDiff
              };
              if(tag.helpTag && newInfo.msgType === 1){
                console.log('resetting location info for help tag!')
                tag.location = {}
                tag.zone = {}
              }
            }
          }
          if (newInfo.battery) {
            tag.battery = newInfo.battery;
          }
        }
        return { ...tag };
      });
      //sort by last seen
      data.sort((a,b)=>{
        let t1 = a.time.lastEventTime || OLD_DATE_FOR_SORT;
        let t2 = b.time.lastEventTime || OLD_DATE_FOR_SORT;
        if(t1 < t2){
          return 1;
        }
        if(t1 >  t2){
          return -1;
        }
        return 0;
      });

      return {
        ...state,
        data: Array.from(data)
      };
    }
    case actions.REMOVE_TAG: {
      const data = state.data.filter(tag => tag.id !== action.tag.id);
      return {
        ...state,
        data
      };
    }
    case actions.ADDED_TAG: {
      let newInfo = action.tag;
      let found = false;
      let data = state.data.map(tag => {
        if (tag.id === newInfo.id) {
          found = true;
          return newInfo;
        }
        return tag;
      });
      if (!found) {
        data.push(action.tag);
      }
      return {
        ...state,
        data: Array.from(data)
      };
    }
    case actions.SET_HISTORY:
      let d = action.data;
      let geodata = false;
      let geoclustered = false;
      let sortedevents = [];
      if (Array.isArray(d)) {
        geodata = {
          type: 'FeatureCollection',
          features: []
        };
        d.forEach(i => {
          if (i.longitude && i.time) {
            geodata.features.push({
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: [i.longitude, i.latitude]
              },
              properties: {
                time: i.time.toISOString(),
                etype: i.etype
              }
            });
          }
        });

        let c = dobbyscan(
          geodata.features,
          0.01,
          p => p.geometry.coordinates[0],
          p => p.geometry.coordinates[1]
        );
        geoclustered = {
          type: 'FeatureCollection',
          features: []
        };

        let timed = [];
        c.forEach((cl, clid) => {
          cl.forEach(f => {
            timed.push({ c: clid, d: new Date(f.properties.time).getTime() });
          });
        });
        let sortedtimed = timed.sort((a, b) => {
          if (a.d > b.d) {
            return 1;
          }
          if (b.d > a.d) {
            return -1;
          }
          return 0;
        });

        let i = 0;
        sortedevents = sortedtimed.splice(0, 1);
        let sortedl = sortedtimed.length;
        while (i < sortedl) {
          let l = sortedevents.length;
          let nxt = sortedtimed.splice(0, 1)[0];
          let cur = sortedevents[l - 1];
          if (cur.c === nxt.c) {
            cur.cont = nxt.d;
          } else {
            sortedevents.push(nxt);
          }
          i += 1;
        }

        c.forEach((cl, idx) => {
          geoclustered.features.push(cl[0]);
          sortedevents.forEach(s => {
            if (s.c === idx) {
              s.coordinates = cl[0].geometry.coordinates;
            }
          });
        });
      }

      return {
        ...state,
        historyGeodata: geoclustered,
        historySortedEvents: sortedevents,
        currentHistory: action.data,
        currentTag: state.data.find(tag => tag.id === action.id)
      };
    case actions.BULK_UPLOAD: 
      return {
        ...state,
        loading: true
      };
    case actions.BULK_UPLOAD_FINISHED:
      return {
        ...state,
        bulkResults: action.data,
        loading: false
      };
    case actions.BULK_UPLOAD_CLEAR:
      return {
        ...state,
        bulkResults: {},
        loading: false
      };
    case actions.EXPORTED_TAG_LIST:
      return {
        ...state,
        loading: false
      };
    case actions.EXPORT_TAG_LIST:
      return {
        ...state,
        loading: true
      };
    case actions.SET_SORTING:
      const currentSorting = state.sorting;
      const inputSorting = action.sorting;
      let sorting = inputSorting;
      if (typeof inputSorting.descendingOrder !== 'boolean') {
        if (currentSorting.column === inputSorting.column) {
          sorting = {
            ...sorting,
            descendingOrder: !currentSorting.descendingOrder
          };
        } else {
          sorting = {
            ...sorting,
            descendingOrder: false
          };
        }
      }
      return {
        ...state,
        sorting
      };
    case actions.SET_FILTERS:
      return {
        ...state,
        field1FilterValues: action.filters.field1,
        field2FilterValues: action.filters.field2
      }
    case actions.ERROR:
      return {
        ...state,
        loading: false
      }
    case actions.LOGGED_OUT:
        return defaultState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/tags/index.js